import type { ExtractPropTypes } from "vue";
export const ModulePropsOption = {
    name: { type: String, required: true },
    type: { type: String, required: true },
} as const;

export type ModuleProps = ExtractPropTypes<typeof ModulePropsOption>;